import React from 'react'

import { Text, View, Image, StyleSheet,} from '@react-pdf/renderer';
import Chart from '../../../Assets/Images/gap-analysis-chart.png'

const GapAnalysisPage = () => {
  const styles = StyleSheet.create({
    page: {
      paddingHorizontal: 21,
      paddingVertical: 30,
      backgroundColor: '#FFFFFF',
      justifyContent: "space-between",
      height: '100%'
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderBottom: '1px solid #00577D',
      paddingBottom: 5,
      marginBottom: 2,
      marginTop: '-15px'
    },
    titlemain: {
      fontSize: 12,
      fontWeight: 700,
      color: '#76A3BE',
    },
    title: {
      fontSize: 11,
      fontWeight: 200,
      color: '#76A3BE',
    },
    rightsection: {
      alignItems: 'flex-end',
      flexDirection: 'column',
      flex: 1,
    },
    rightText: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    rightTextsybtext: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    section: {
      gap: 10,
      marginBottom: 20
    },
    headertext: {
      fontSize: 18,
      fontWeight: 700,
      color: '#426B88',
      marginLeft: 0,
      paddingLeft: 0,
      marginBottom: 10,
    },
    paragraph: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      lineHeight: '18px',
    },
    container: {
      flexDirection: 'row',
      marginTop: 20,
      fontFamily: 'Lato',
    },
    containerrightsection: {
      marginLeft: 25,
      maxWidth: 295,
      lineHeight: '18px',
      gap: 15
    },
    image: {
      width: 231,
      height: 231,
      alignSelf: 'center',
    },
    flowimg: {
      marginTop: 30,
    },
    paragraphtopspace: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      marginTop: 12
    },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
    chart: {
      height: 215,
      width: 510,
    }
  });

  return (
    <View style={styles.page}>
      <View>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerleft}>
            <Text style={styles.titlemain}>QUADRANT FLOW</Text>
            <Text style={styles.title}>Life & Leadership Assssment</Text>
          </View>
          <View style={styles.rightsection}>
            <Text style={styles.rightText}>Rob Murray</Text>
            <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
          </View>
        </View>

        <View style={styles.container}>
          <View>
            <Text style={styles.headertext}>ALIGNMENT FLOW GAP ANALYSIS</Text>
          </View>
        </View> 

        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>      
            Comparing your Starter Quadrant and flow with your Leadership Style and flow provides invaluable insight. Are there alignments or differences? For some, there is congruence between “who you are” and “how you lead.” For others, there are differences that invite conversation and exploration.
          </Text>
          <Text style={styles.paragraph}>
            The resulting discrepancies aren't about right or wrong but highlight differing perceptions and experiences, offering a starting point for meaningful dialogue. The instinct might be to sidestep this Flow Gap analysis; however, we argue for embracing growth and seeking alignment as essential steps toward fortifying your future, both personally and professionally.
          </Text>
          <Text style={styles.paragraph}>
            Our natural reaction to gaps is often to adapt unauthentically, justify shortcomings, or overcompensate to conceal these disparities. While these strategies may offer temporary solace, the truth inevitably surfaces, sometimes in unexpected ways.
          </Text>
          <Text style={styles.paragraph}>
            Cultivating curiosity about its origins and then choosing either to navigate around it or, more bravely, to address it head-on aims to bridge the divide. This process of deliberate action toward closing the gap is crucial in evolving into a more authentic and aligned version of oneself.
          </Text>
        </View>
        <Image src={Chart} style={styles.chart} />
      </View>
      
      {/* Footer Section */}
      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>SELF REPORT</Text>
          <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>
  );
}

export default GapAnalysisPage